/*
 * patient-signature (schema)
 */
import { boolean, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { users } from "../user/user.schema"

export const patientSignatures = schema.table("patient_signatures", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),

	// --- Data ---
	signatureData: text("signature_data").notNull(), // base64 data URL (PNG)

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
